import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Upload } from "lucide-react";
import { UploadDialog } from "./UploadDialog";

interface KnowledgeBaseHeaderProps { }

export function KnowledgeBaseHeader({ }: KnowledgeBaseHeaderProps) {
  const { t } = useTranslation();
  const [uploadDialogOpen, setUploadDialogOpen] = useState(false);

  return (
    <>
      <div className="mb-4 flex items-center justify-between">
        <div>
          <h2 className="text-xl font-semibold text-gray-900">{t("knowledgeBase.title")}</h2>
          <p className="text-gray-600">{t("knowledgeBase.description")}</p>
        </div>
        <Button
          onClick={() => setUploadDialogOpen(true)}
          className="flex items-center gap-2"
          title={t("knowledgeBase.upload.button")}
        >
          <Upload className="w-4 h-4" />
        </Button>
      </div>

      <UploadDialog
        open={uploadDialogOpen}
        onOpenChange={setUploadDialogOpen}
      />
    </>
  );
}
